const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const parseResponse = async (response, fallbackMessage) => {
  const payload = await response.json().catch(() => null);
  if (response.ok) {
    return payload;
  }
  const message = payload?.detail || payload?.message || fallbackMessage || `Request failed (${response.status})`;
  const error = new Error(message);
  error.status = response.status;
  error.payload = payload;
  throw error;
};

export async function fetchAllIfrsStandards() {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards`, {
    headers: buildHeaders()
  });
  return parseResponse(response, 'IFRS standartları listelenemedi.');
}

export async function fetchActiveIfrsStandards() {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards/active`, {
    headers: buildHeaders()
  });
  return parseResponse(response, 'Aktif IFRS standartları listelenemedi.');
}

export async function fetchIfrsStandardById(id) {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards/${id}`, {
    headers: buildHeaders()
  });
  return parseResponse(response, 'IFRS standardı bulunamadı.');
}

export async function fetchIfrsStandardByCode(code) {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards/code/${encodeURIComponent(code)}`, {
    headers: buildHeaders()
  });
  return parseResponse(response, `IFRS standardı bulunamadı: ${code}`);
}

export async function createIfrsStandard(data) {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(data)
  });
  return parseResponse(response, 'IFRS standardı oluşturulamadı.');
}

export async function updateIfrsStandard(id, data) {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards/${id}`, {
    method: 'PUT',
    headers: buildHeaders(),
    body: JSON.stringify(data)
  });
  return parseResponse(response, 'IFRS standardı güncellenemedi.');
}

export async function deactivateIfrsStandard(id) {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards/${id}`, {
    method: 'DELETE',
    headers: buildHeaders()
  });
  if (response.status === 204) return null;
  return parseResponse(response, 'IFRS standardı pasifleştirilemedi.');
}

export async function activateIfrsStandard(id) {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards/${id}/activate`, {
    method: 'PUT',
    headers: buildHeaders()
  });
  return parseResponse(response, 'IFRS standardı aktifleştirilemedi.');
}

export async function syncIfrsStandardsFromJson(standardsList) {
  const response = await fetch(`${API_BASE}/api/system/ifrs-standards/sync`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(standardsList)
  });
  return parseResponse(response, 'KGK senkronizasyonu başarısız.');
}
